(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-age-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STAGE_COPY = {
    dog: {
      puppy: {
        name: 'Puppy',
        interp: 'Your dog is in a fast-growth phase. Body, brain, and behavior are all wiring up at the same time, which is exciting and demanding in equal measure.',
        list: [
          'Rapid physical development and high energy bursts followed by deep sleep.',
          'Active socialization and learning windows.',
          'Sensitive digestion and a still-maturing immune system.'
        ],
        goal: 'Steady growth, a calm nervous system, and consistent routines. Focus on quality nutrition, predictable rest, and gentle daily structure.'
      },
      young: {
        name: 'Young Adult',
        interp: 'Your dog is in their physical prime — strong, agile, and emotionally settled. This is the foundation stage for long-term vitality.',
        list: [
          'Peak physical performance and stamina.',
          'Stable behavior patterns and clear preferences.',
          'High recovery capacity and resilience.'
        ],
        goal: 'Lock in consistency. Quality food, regular movement, restorative sleep, and routine wellness checks build the baseline that supports the next decade of life.'
      },
      mature: {
        name: 'Mature Adult',
        interp: 'Outwardly, little has changed. Internally, this is a quiet pivot. Cellular wear and oxidative stress begin to accumulate, and recovery time shifts.',
        list: [
          'Subtle changes in energy, recovery, and weight management.',
          'Joints and connective tissues begin to show normal wear.',
          'Cognitive sharpness remains, but the foundation matters more than ever.'
        ],
        goal: 'Begin proactive support for cellular energy, antioxidant defense, and joint comfort — well before visible signs of aging appear.'
      },
      senior: {
        name: 'Senior',
        interp: 'Your dog is in a stage where small changes matter. Comfort, cognition, and recovery deserve close, gentle attention.',
        list: [
          'Slower recovery from activity and possible joint stiffness.',
          'Shifts in sleep patterns and energy throughout the day.',
          'More sensitivity to environmental stress and routine changes.'
        ],
        goal: 'Help maintain comfort, mobility, and mental engagement. Gentle daily support, soft routines, and consistent connection are foundational.'
      },
      advanced: {
        name: 'Advanced Senior',
        interp: 'Your dog has earned a slower rhythm. The priority is dignity, comfort, and presence — not performance.',
        list: [
          'Lower energy and shorter activity windows.',
          'More need for warmth, soft surfaces, and quiet environments.',
          'Greater sensitivity to changes in food, schedule, and surroundings.'
        ],
        goal: 'Help maintain quality of life. Soft daily structure, gentle support, and close attention to subtle changes matter most now.'
      }
    },
    cat: {
      kitten: {
        name: 'Kitten',
        interp: 'Your cat is in a fast-growth stage. Coordination, social behavior, and physical structure are all developing rapidly.',
        list: [
          'Rapid growth and bursts of intense play.',
          'Active learning, especially around environment and people.',
          'Sensitive digestion and a maturing immune system.'
        ],
        goal: 'Steady growth and a calm environment. Quality nutrition, gentle handling, and predictable routines build a confident adult cat.'
      },
      young: {
        name: 'Young Adult',
        interp: 'Your cat is at their physical peak — agile, curious, and self-assured. This is the right stage to lock in habits that pay off later.',
        list: [
          'Peak agility, hunting drive, and stamina.',
          'Stable social patterns and well-defined preferences.',
          'Strong recovery and resilience.'
        ],
        goal: 'Consistency. Clean hydration, quality nutrition, daily play, and a low-stress environment build the foundation for a long, healthy life.'
      },
      mature: {
        name: 'Mature Adult',
        interp: 'Outwardly, your cat looks the same. Internally, this is a quiet but meaningful window. Cellular wear and oxidative stress begin to shift.',
        list: [
          'Subtle changes in activity level and weight management.',
          'Slightly slower recovery after intense play.',
          'Cognitive sharpness intact, but groundwork starts mattering more.'
        ],
        goal: 'Begin proactive support for cellular energy and antioxidant defense, well before visible signs of aging appear.'
      },
      senior: {
        name: 'Senior',
        interp: 'Your cat is at a stage where small changes matter. Mobility, hydration, and comfort deserve close, gentle attention.',
        list: [
          'Reduced jumping height and slower movement after rest.',
          'Shifts in sleep patterns and grooming routines.',
          'More sensitivity to environmental and dietary changes.'
        ],
        goal: 'Help maintain comfort, mobility, and engagement. Soft surfaces, easy access to favorite spots, and gentle daily support carry weight here.'
      },
      advanced: {
        name: 'Advanced Senior',
        interp: 'Your cat is in a stage that asks for stillness, warmth, and close attention. The priority is dignity and quality of daily life.',
        list: [
          'Lower energy and shorter active windows.',
          'Greater need for warmth, soft surfaces, and quiet.',
          'More sensitivity to changes in food, schedule, and environment.'
        ],
        goal: 'Help maintain quality of life through gentle daily structure, careful observation of subtle changes, and consistent, supportive routines.'
      }
    }
  };

  function ageFromDob(dobStr) {
    if (!dobStr) return null;
    var dob = new Date(dobStr);
    if (isNaN(dob.getTime())) return null;
    var now = new Date();
    if (dob > now) return null;
    var years = now.getFullYear() - dob.getFullYear();
    var months = now.getMonth() - dob.getMonth();
    var days = now.getDate() - dob.getDate();
    if (days < 0) months -= 1;
    if (months < 0) { years -= 1; months += 12; }
    return { years: years, months: months };
  }

  function convert(ageY, sp, size) {
    if (ageY <= 0) return 0;
    if (ageY <= 1) return ageY * 15;
    if (ageY <= 2) return 15 + (ageY - 1) * 9;
    var increment;
    if (sp === 'dog') {
      increment = ({ small: 4, medium: 5, large: 6, giant: 7 })[size] || 5;
    } else {
      increment = 4;
    }
    return 24 + (ageY - 2) * increment;
  }

  function lifeStage(ageY, sp, size) {
    if (sp === 'cat') {
      if (ageY < 1) return 'kitten';
      if (ageY < 4) return 'young';
      if (ageY < 7) return 'mature';
      if (ageY < 11) return 'senior';
      return 'advanced';
    }
    var brackets = ({
      small:  [1, 4, 8, 12],
      medium: [1, 4, 7, 11],
      large:  [1, 3, 6, 9],
      giant:  [1, 3, 5, 8]
    })[size] || [1, 4, 7, 11];
    if (ageY < brackets[0]) return 'puppy';
    if (ageY < brackets[1]) return 'young';
    if (ageY < brackets[2]) return 'mature';
    if (ageY < brackets[3]) return 'senior';
    return 'advanced';
  }

  function formatHuman(num) {
    if (num < 10) return (Math.round(num * 10) / 10).toString();
    return Math.round(num).toString();
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var species = root.getAttribute('data-species') || 'dog';
    var form    = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var modeBtns       = form.querySelectorAll('.lpl-ac-mode-btn');
    var paneAge        = form.querySelector('[data-pane="age"]');
    var paneDob        = form.querySelector('[data-pane="dob"]');
    var yearsEl        = form.querySelector('[data-field="years"]');
    var monthsEl       = form.querySelector('[data-field="months"]');
    var dobEl          = form.querySelector('[data-field="dob"]');
    var errorEl        = form.querySelector('[data-error]');
    var resetBtn       = form.querySelector('[data-reset]');
    var resultEl       = root.querySelector('[data-result]');
    var resultNum      = root.querySelector('[data-result-number]');
    var resultSummary  = root.querySelector('[data-result-summary]');
    var stageNameEl    = root.querySelector('[data-stage-name]');
    var stageInterpEl  = root.querySelector('[data-stage-interp]');
    var stageListEl    = root.querySelector('[data-stage-list]');
    var stageGoalEl    = root.querySelector('[data-stage-goal]');

    var mode = 'age';

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function speciesLabel() { return species === 'dog' ? 'dog' : 'cat'; }

    modeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mode = btn.getAttribute('data-mode');
        modeBtns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        paneAge.classList.toggle('is-hidden', mode !== 'age');
        paneDob.classList.toggle('is-hidden', mode !== 'dob');
        clearError();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    function render(humanAge, stageKey) {
      var copy = STAGE_COPY[species][stageKey];
      if (!copy) return;
      resultNum.textContent = formatHuman(humanAge);
      resultSummary.textContent = 'Your ' + speciesLabel() + ' is approximately ' + formatHuman(humanAge) + ' human years old.';
      stageNameEl.textContent = copy.name;
      stageInterpEl.textContent = copy.interp;
      stageListEl.innerHTML = '';
      copy.list.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        stageListEl.appendChild(li);
      });
      stageGoalEl.textContent = copy.goal;
      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var years = 0;
      var months = 0;

      if (mode === 'age') {
        years = parseInt(yearsEl.value, 10);
        months = parseInt(monthsEl.value, 10);
        if (isNaN(years)) years = 0;
        if (isNaN(months)) months = 0;
        if (years < 0 || months < 0) { setError('Please enter a positive number.'); return; }
        if (months > 11) { setError('Months must be between 0 and 11.'); return; }
        if (years === 0 && months === 0) { setError('Please enter your ' + speciesLabel() + '’s age.'); return; }
        if (years > 30) { setError('Please enter a realistic age.'); return; }
      } else {
        var parsed = ageFromDob(dobEl.value);
        if (!parsed) { setError('Please enter a valid date of birth.'); return; }
        years = parsed.years;
        months = parsed.months;
        if (years === 0 && months === 0) { setError('Date of birth must be in the past.'); return; }
      }

      var size = null;
      if (species === 'dog') {
        var sizeInput = form.querySelector('input[name="size"]:checked');
        size = sizeInput ? sizeInput.value : 'medium';
      }

      var ageY = years + months / 12;
      var human = convert(ageY, species, size);
      var stage = lifeStage(ageY, species, size);
      render(human, stage);
    });
  }

  function ready() {
    document.querySelectorAll('[data-lpl-ac]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-ac]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-calorie-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Multipliers over RER (Resting Energy Requirement = 70 * kg^0.75)
  // Indexed by species -> age -> activity. Intact baseline; neutered modifier applied separately.
  var MULT = {
    dog: {
      puppy:  { low: 2.0, moderate: 2.5, high: 3.0 },
      adult:  { low: 1.4, moderate: 1.6, high: 2.0 },
      senior: { low: 1.2, moderate: 1.4, high: 1.6 }
    },
    cat: {
      kitten: { low: 2.0, moderate: 2.5, high: 3.0 },
      adult:  { low: 1.2, moderate: 1.4, high: 1.6 },
      senior: { low: 1.1, moderate: 1.2, high: 1.4 }
    }
  };

  // Neutered modifier (applied only to adult & senior; growing animals not adjusted).
  var NEUTERED_MOD = 0.9;

  // Body-condition goal modifier on top of maintenance.
  var GOAL_MOD = { maintain: 1.0, lose: 0.8, gain: 1.15 };

  // Interpretation copy keyed by species_age_activity
  var INTERP = {
    dog: {
      puppy:  {
        low:      'Even a quieter puppy is in a fast-growth window. Calorie needs are high, but quality and consistency matter even more than quantity.',
        moderate: 'This is typical for a growing puppy with steady daily play and short walks. Frequent, structured meals support healthy growth.',
        high:     'Active, fast-growing puppies can need two to three times the maintenance calories of an adult their eventual size.'
      },
      adult: {
        low:      'This is typical for an adult dog with limited daily activity. Consistency of intake matters more than novelty at this stage.',
        moderate: 'This is typical for a moderately active adult dog. Most healthy adults sit comfortably in this range with daily movement.',
        high:     'This is typical for a working, sporting, or highly active adult dog. Calorie needs scale meaningfully with sustained effort.'
      },
      senior: {
        low:      'Senior dogs typically need fewer calories than they did as adults, but the importance of nutrient density and recovery support increases.',
        moderate: 'A moderately active senior dog often sits slightly below their adult intake. Quality and consistency outweigh quantity at this stage.',
        high:     'Even active senior dogs typically need slightly fewer calories than they did as adults, with greater attention to recovery and joint comfort.'
      }
    },
    cat: {
      kitten: {
        low:      'Even a calmer kitten is in a fast-growth phase. Calorie needs are high, with quality protein and frequent meals as the foundation.',
        moderate: 'This is typical for a growing kitten with regular play and exploration. Frequent meals support healthy growth.',
        high:     'Active, fast-growing kittens can need two to three times the maintenance calories of an adult cat per pound of body weight.'
      },
      adult: {
        low:      'This is typical for an adult indoor cat. Indoor cats generally need fewer calories than active outdoor cats — movement, not personality, is the variable.',
        moderate: 'This is typical for an adult cat with regular play and indoor activity. Sustained daily movement keeps this range steady.',
        high:     'This is typical for an active, often outdoor, adult cat. Hunting, climbing, and temperature regulation all add to daily calorie demand.'
      },
      senior: {
        low:      'Senior cats typically need slightly fewer calories, but nutrient density, hydration, and recovery support become more important.',
        moderate: 'A moderately active senior cat often sits slightly below their adult intake, with greater emphasis on maintaining lean muscle.',
        high:     'Even active senior cats typically need slightly fewer calories than they did as adults, with greater attention to recovery and lean muscle.'
      }
    }
  };

  var LIFESTAGE = {
    dog: {
      puppy:  'Puppies are building structure, immunity, and behavior at the same time. The goal is steady growth — quality protein, predictable meals, and a calm nervous system.',
      adult:  'Adult dogs benefit most from consistency. A steady daily intake tuned to activity level builds the foundation for long-term vitality.',
      senior: 'Senior dogs benefit from nutrient density, recovery support, and a thoughtful daily rhythm. Calorie needs decline; nutritional quality should not.'
    },
    cat: {
      kitten: 'Kittens grow at a remarkable pace. The goal is steady growth — high-quality protein, frequent meals, and a calm environment.',
      adult:  'Adult cats benefit from consistency. A steady daily intake tuned to indoor or outdoor lifestyle builds the foundation for long-term vitality.',
      senior: 'Senior cats benefit from nutrient density, hydration, and recovery support. Maintaining lean muscle is a quiet but pivotal goal in older cats.'
    }
  };

  function getWeightGuidance(goal, sp) {
    if (goal === 'lose') {
      if (sp === 'cat') {
        return 'Cats should not lose weight quickly — rapid calorie restriction can lead to serious metabolic complications. Any feline weight-loss plan should be designed and monitored by your veterinarian.';
      }
      return 'Healthy weight loss is slow. Reassess body condition every two to four weeks and avoid aggressive calorie cuts that compromise muscle and recovery. A veterinarian can help guide pace.';
    }
    if (goal === 'gain') {
      return 'Healthy weight gain is gradual. If your pet has been losing weight unintentionally — or struggling to gain despite adequate intake — discuss the underlying cause with your veterinarian.';
    }
    return 'Body condition is the best feedback loop — observe over weeks, not days. If your pet is gaining or losing weight unintentionally, discuss calorie adjustments with your veterinarian.';
  }

  function getTreatGuidance(target, treatPct) {
    if (treatPct == null || treatPct <= 0) {
      return 'Veterinary guidance generally recommends keeping treats under 10% of daily intake. For this estimate, that is roughly ' + Math.round(target * 0.10) + ' calories per day.';
    }
    var treatCals = Math.round(target * (treatPct / 100));
    var mealCals = Math.round(target - treatCals);
    return 'At ' + treatPct + '% from treats, aim to keep treats under ~' + treatCals + ' kcal/day, with ~' + mealCals + ' kcal from balanced meals.';
  }

  function calc(weightKg, sp, age, activity, neutered, goal) {
    var rer = 70 * Math.pow(weightKg, 0.75);
    var base = (MULT[sp][age] && MULT[sp][age][activity]) || 1.4;
    var adjusted = base;
    if (neutered && (age === 'adult' || age === 'senior')) {
      adjusted = base * NEUTERED_MOD;
    }
    adjusted *= (GOAL_MOD[goal] || 1.0);
    return rer * adjusted;
  }

  function formatCal(n) {
    if (n < 100) return Math.round(n).toString();
    return Math.round(n / 5) * 5 + '';
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var species = root.getAttribute('data-species') || 'dog';
    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var weightEl   = form.querySelector('[data-field="weight"]');
    var neuteredEl = form.querySelector('[data-field="neutered"]');
    var treatsEl   = form.querySelector('[data-field="treats"]');
    var sliderVal  = form.querySelector('[data-slider-value]');
    var errorEl    = form.querySelector('[data-error]');
    var resetBtn   = form.querySelector('[data-reset]');
    var resultEl   = root.querySelector('[data-result]');
    var numEl      = root.querySelector('[data-result-number]');
    var rangeEl    = root.querySelector('[data-result-range]');
    var interpEl   = root.querySelector('[data-interp]');
    var treatBlock = root.querySelector('[data-treat-block]');
    var treatEl    = root.querySelector('[data-treats]');
    var weightOutEl = root.querySelector('[data-weight]');
    var lifestageEl = root.querySelector('[data-lifestage]');

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }

    // Slider live value
    if (treatsEl && sliderVal) {
      var syncSlider = function () { sliderVal.textContent = treatsEl.value + '%'; };
      treatsEl.addEventListener('input', syncSlider);
      syncSlider();
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (treatsEl && sliderVal) sliderVal.textContent = treatsEl.value + '%';
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var weight = parseFloat(weightEl.value);
      if (isNaN(weight) || weight <= 0) { setError('Please enter your ' + species + '’s weight.'); return; }

      var unitInput = form.querySelector('input[name="unit"]:checked');
      var unit = unitInput ? unitInput.value : 'lb';
      var weightKg = unit === 'kg' ? weight : weight / 2.20462;

      // Sanity check
      var maxKg = species === 'dog' ? 110 : 15;
      if (weightKg > maxKg) { setError('Please enter a realistic weight.'); return; }
      if (weightKg < 0.2) { setError('Please enter a realistic weight.'); return; }

      var ageInput      = form.querySelector('input[name="age"]:checked');
      var activityInput = form.querySelector('input[name="activity"]:checked');
      var goalInput     = form.querySelector('input[name="goal"]:checked');

      var age      = ageInput ? ageInput.value : 'adult';
      var activity = activityInput ? activityInput.value : 'moderate';
      var goal     = goalInput ? goalInput.value : 'maintain';
      var neutered = neuteredEl ? neuteredEl.checked : true;

      var target = calc(weightKg, species, age, activity, neutered, goal);
      var low = target * 0.93;
      var high = target * 1.07;

      numEl.textContent = formatCal(target);
      rangeEl.textContent = 'Typical range: ' + formatCal(low) + '–' + formatCal(high) + ' kcal / day';

      var interpCopy = (INTERP[species][age] && INTERP[species][age][activity]) || '';
      if (neutered && (age === 'adult' || age === 'senior')) {
        interpCopy += ' Neutered pets typically need around 10–20% fewer calories than intact pets — already reflected here.';
      }
      interpEl.textContent = interpCopy;

      var treatPct = treatsEl ? parseInt(treatsEl.value, 10) : null;
      if (treatBlock && treatEl) {
        if (species === 'dog') {
          treatBlock.hidden = false;
          treatEl.textContent = getTreatGuidance(target, treatPct);
        } else {
          treatBlock.hidden = false;
          treatEl.textContent = getTreatGuidance(target, null);
        }
      }

      weightOutEl.textContent = getWeightGuidance(goal, species);
      lifestageEl.textContent = LIFESTAGE[species][age] || '';

      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function ready() {
    document.querySelectorAll('[data-lpl-cc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-cc]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-hydration-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Base water requirement: ~50 ml per kg per day (≈ 1 oz per lb).
  var BASE_ML_PER_KG = 50;

  // Age-stage adjustments (growing animals need more relative to size).
  var AGE_ADJ = {
    puppy:  1.15,
    kitten: 1.15,
    adult:  1.00,
    senior: 1.00
  };

  // Activity adjustments.
  var ACTIVITY_ADJ = { low: 1.0, moderate: 1.1, high: 1.25 };

  // Climate adjustments.
  var CLIMATE_ADJ = { temperate: 1.0, hot: 1.3 };

  // Food moisture share of daily water (fraction provided by food).
  var FOOD_WATER_SHARE = {
    dry:   0.05,
    mixed: 0.30,
    wet:   0.55
  };

  var FOOD_MOISTURE_COPY = {
    dry:   'Dry kibble contains about 10% moisture. On a primarily dry diet, your pet needs to drink nearly all of their daily water from the bowl. Multiple fresh water stations help keep intake steady.',
    mixed: 'A mixed diet of wet and dry food provides moderate water from meals — typically around a quarter to a third of daily needs. The rest should come from drinking.',
    wet:   'Wet food is about 70–80% moisture and can provide roughly half of daily water needs. Pets on primarily wet diets often drink noticeably less from the bowl — this is generally normal, not concerning.'
  };

  var HEALTHY_SIGNS = [
    'Moist, pink gums that refill color quickly when gently pressed',
    'Skin that returns to position promptly when gently lifted at the shoulders',
    'Bright, alert eyes and steady energy through the day',
    'Regular urination — typical color, typical frequency'
  ];

  var MONITOR_SIGNS = {
    dog: [
      'Drinking noticeably more or less than usual for several days',
      'Dry, tacky gums or sunken-looking eyes',
      'Lethargy, reduced appetite, or unusual sleepiness',
      'Vomiting, diarrhea, or known fluid loss',
      'Skin that returns slowly when gently lifted'
    ],
    cat: [
      'Drinking noticeably more or less than usual for several days',
      'Dry, tacky gums or sunken-looking eyes',
      'Lethargy, hiding, or unusual sleepiness',
      'Vomiting, diarrhea, or known fluid loss',
      'Reduced urination or changes in litter-box habits'
    ]
  };

  var TIPS = {
    dog: {
      general: [
        'Provide fresh water in clean bowls, refilled at least daily',
        'Place multiple water stations around the home, especially on different floors',
        'Offer cool (not ice-cold) water after activity or in heat',
        'Consider adding wet food or a splash of low-sodium broth to dry meals if drinking is low',
        'Bring water on walks and longer outings, especially in warm weather'
      ],
      senior: [
        'Place water stations near rest spots so a senior dog doesn\'t have to travel far',
        'Use shallow, wide bowls — easier for stiff necks',
        'Refresh water more often; older dogs are often more sensitive to taste and smell',
        'Consider adding wet food or warm-water-softened kibble to support steady moisture intake',
        'Watch trends over weeks, not days — gradual changes in drinking are easy to miss'
      ]
    },
    cat: {
      general: [
        'Place water bowls away from food bowls — cats often prefer the separation',
        'Use wide, shallow ceramic or glass bowls; many cats dislike narrow bowls that touch their whiskers',
        'Offer multiple water stations, especially in larger homes or multi-cat households',
        'Consider a pet fountain — many cats prefer moving water',
        'Including some wet food in the diet supports steady hydration for low-thirst-drive cats'
      ],
      senior: [
        'Place water stations near favorite rest spots and on every floor a senior cat uses',
        'Use wide, shallow bowls — easier for older cats with stiffer necks',
        'Refresh water more often; senior cats are often more sensitive to taste and smell',
        'A pet fountain can encourage drinking if a senior cat starts visiting the bowl less',
        'Watch trends over weeks, not days — gradual changes in drinking are easy to miss'
      ]
    }
  };

  function mlToCups(ml) { return ml / 240; }
  function mlToFlOz(ml) { return ml / 29.5735; }

  function roundCups(c) {
    // Round to nearest 0.25 cup
    return Math.round(c * 4) / 4;
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var species = root.getAttribute('data-species') || 'dog';
    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var weightEl   = form.querySelector('[data-field="weight"]');
    var errorEl    = form.querySelector('[data-error]');
    var resetBtn   = form.querySelector('[data-reset]');
    var resultEl   = root.querySelector('[data-result]');
    var cupsEl     = root.querySelector('[data-result-cups]');
    var metaEl     = root.querySelector('[data-result-meta]');
    var rangeEl    = root.querySelector('[data-result-range]');
    var foodSplitEl   = root.querySelector('[data-food-split]');
    var foodMoistureEl = root.querySelector('[data-food-moisture]');
    var healthyEl  = root.querySelector('[data-healthy]');
    var monitorEl  = root.querySelector('[data-monitor]');
    var tipsEl     = root.querySelector('[data-tips]');
    var tipsHEl    = root.querySelector('[data-tips-h]');

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    function fillList(el, items) {
      el.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        el.appendChild(li);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var weight = parseFloat(weightEl.value);
      if (isNaN(weight) || weight <= 0) { setError('Please enter your ' + species + '\'s weight.'); return; }

      var unitInput = form.querySelector('input[name="unit"]:checked');
      var unit = unitInput ? unitInput.value : 'lb';
      var weightKg = unit === 'kg' ? weight : weight / 2.20462;

      var maxKg = species === 'dog' ? 110 : 15;
      if (weightKg > maxKg) { setError('Please enter a realistic weight.'); return; }
      if (weightKg < 0.2)   { setError('Please enter a realistic weight.'); return; }

      var age      = (form.querySelector('input[name="age"]:checked') || {}).value || 'adult';
      var diet     = (form.querySelector('input[name="diet"]:checked') || {}).value || 'dry';
      var activity = (form.querySelector('input[name="activity"]:checked') || {}).value || 'moderate';
      var climate  = (form.querySelector('input[name="climate"]:checked') || {}).value || 'temperate';

      var totalMl = weightKg * BASE_ML_PER_KG;
      totalMl *= (AGE_ADJ[age] || 1.0);
      totalMl *= (ACTIVITY_ADJ[activity] || 1.0);
      totalMl *= (CLIMATE_ADJ[climate] || 1.0);

      var fromFoodMl = totalMl * (FOOD_WATER_SHARE[diet] || 0.05);
      var fromBowlMl = totalMl - fromFoodMl;

      var totalCups = roundCups(mlToCups(totalMl));
      var lowCups   = roundCups(mlToCups(totalMl * 0.9));
      var highCups  = roundCups(mlToCups(totalMl * 1.1));
      var totalOz   = Math.round(mlToFlOz(totalMl));
      var totalMlRounded = Math.round(totalMl / 10) * 10;

      var bowlCups = roundCups(mlToCups(fromBowlMl));
      var foodCups = roundCups(mlToCups(fromFoodMl));

      cupsEl.textContent = totalCups.toFixed(2).replace(/\.?0+$/, '');
      metaEl.textContent = '≈ ' + totalOz + ' fl oz · ' + totalMlRounded + ' ml per day (total water need, including food)';
      rangeEl.textContent = 'Typical range: ' + lowCups + '–' + highCups + ' cups / day';

      foodSplitEl.textContent =
        'About ' + bowlCups + ' cups from drinking water and ~' + foodCups + ' cups from food. ' +
        'These are estimates — actual contribution from food depends on diet composition and serving size.';

      foodMoistureEl.textContent = FOOD_MOISTURE_COPY[diet] || FOOD_MOISTURE_COPY.dry;

      fillList(healthyEl, HEALTHY_SIGNS);
      fillList(monitorEl, MONITOR_SIGNS[species]);

      if (age === 'senior') {
        tipsHEl.textContent = 'Hydration tips for senior pets';
        fillList(tipsEl, TIPS[species].senior);
      } else {
        tipsHEl.textContent = 'Everyday hydration tips';
        fillList(tipsEl, TIPS[species].general);
      }

      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function ready() {
    document.querySelectorAll('[data-lpl-hc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-hc]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-life-stage-framework"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var rail = root.querySelector('.lpl-ls-rail');
    if (!rail) return;
    var buttons = rail.querySelectorAll('.lpl-ls-railbtn');
    var panels = root.querySelectorAll('.lpl-ls-panel');

    function activate(stage) {
      buttons.forEach(function (b) {
        var active = b.getAttribute('data-stage') === stage;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var active = p.getAttribute('data-panel') === stage;
        p.classList.toggle('is-active', active);
        if (active) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        activate(b.getAttribute('data-stage'));
      });
    });

    // Keyboard navigation across tabs
    rail.addEventListener('keydown', function (e) {
      var current = document.activeElement;
      if (!current || !current.classList || !current.classList.contains('lpl-ls-railbtn')) return;
      var list = Array.prototype.slice.call(buttons);
      var idx = list.indexOf(current);
      if (idx < 0) return;
      var next = null;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = list[(idx + 1) % list.length];
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = list[(idx - 1 + list.length) % list.length];
      else if (e.key === 'Home') next = list[0];
      else if (e.key === 'End') next = list[list.length - 1];
      if (next) {
        e.preventDefault();
        next.focus();
        activate(next.getAttribute('data-stage'));
      }
    });

    // Optional: support deep-linking via hash (e.g. #stage=senior)
    var hash = window.location.hash || '';
    var m = hash.match(/stage=([a-z]+)/i);
    if (m && m[1]) {
      var requested = m[1].toLowerCase();
      var exists = Array.prototype.some.call(buttons, function (b) {
        return b.getAttribute('data-stage') === requested;
      });
      if (exists) activate(requested);
    }
  }

  function ready() {
    document.querySelectorAll('[data-lpl-ls]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-ls]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-sleep-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Base sleep ranges by species and life stage (low, high).
  var BASE_RANGE = {
    dog: {
      puppy:  [18, 20],
      adult:  [12, 14],
      senior: [14, 16]
    },
    cat: {
      kitten: [18, 20],
      adult:  [12, 16],
      senior: [15, 18]
    }
  };

  // Adjustments (applied additively to low and high).
  var DOG_SIZE_ADJ = {
    small:  [-1, 0],
    medium: [0, 0],
    large:  [0, 1],
    giant:  [1, 2]
  };

  var ACTIVITY_ADJ = {
    low:      [1, 1],
    moderate: [0, 0],
    high:     [-1, -1]
  };

  var DOG_LIFESTYLE_ADJ = {
    companion: [0, 0],
    working:   [-1, 0]
  };

  var CAT_LIFESTYLE_ADJ = {
    indoor:  [1, 1],
    outdoor: [0, 0]
  };

  // Advanced senior pushes the range up meaningfully.
  var ADVANCED_ADJ = [2, 2];

  var INTERP = {
    dog: {
      puppy:  'Puppies sleep more than any other life stage. Growth, neurological development, and learning all consolidate during deep rest. A puppy that sleeps most of the day, then bursts into intense play, is following normal biology.',
      adult:  'Adult dogs settle into a steady rhythm — deep night sleep with several daytime rest periods. The pattern matters as much as the total hours.',
      senior: 'Senior dogs typically sleep more than they did in their adult years. Recovery takes longer, and rest is increasingly restorative. A gradual increase over months is usually normal aging.'
    },
    cat: {
      kitten: 'Kittens sleep more than any other feline life stage. Growth, neurological development, and learning all consolidate during deep rest. A kitten that sleeps most of the day, then bursts into intense play, is following normal biology.',
      adult:  'Adult cats settle into the classic feline rhythm — short alert bursts and long recovery periods, with deep night sleep and frequent daytime naps.',
      senior: 'Senior cats typically sleep more than they did in their adult years. Stillness becomes more restorative, and recovery takes longer. A gradual increase over months is usually normal aging.'
    }
  };

  var NORMAL_COPY = {
    dog: {
      puppy:  'Yes — this range is typical for a puppy. Sleep is the time when growth and learning consolidate, so high totals are healthy and expected.',
      adult:  'Yes — this range is typical for a healthy adult dog. Look more at the pattern than the total. Easy waking, smooth movement, and engaged play between rests are the signals that matter most.',
      senior: 'Yes — this range is typical for a senior dog. Gradual increases in sleep over months are part of normal aging. Sudden changes, or sleep changes paired with pain or appetite shifts, are worth a closer look.'
    },
    cat: {
      kitten: 'Yes — this range is typical for a kitten. Sleep is the time when growth and learning consolidate, so high totals are healthy and expected.',
      adult:  'Yes — this range is typical for a healthy adult cat. Cats are biologically built for layered rest: easy waking, deep stretches, and brief grooming sessions between sleeps are the signals that matter most.',
      senior: 'Yes — this range is typical for a senior cat. Gradual increases in sleep over months are part of normal aging. Sudden changes, or sleep changes paired with hiding or appetite shifts, are worth a closer look.'
    }
  };

  var AGE_CHANGE_COPY = {
    dog:  'Sleep generally increases with age in dogs. Recovery takes longer, sensory input is more tiring, and the body uses rest to repair more deliberately. This is biologically coherent — not a problem to solve. The shift in pattern matters more than the total.',
    cat:  'Sleep generally increases with age in cats. Stillness becomes more restorative, joints prefer rest, and the body uses sleep to repair more deliberately. This is biologically coherent — not a problem to solve. The shift in pattern matters more than the total.'
  };

  var HEALTHY_COPY = {
    dog: 'Healthy dog rest is layered — most of the day is light, easily interrupted sleep, with several stretches reaching deeper rest. Look for easy waking, smooth stretching, and re-engagement with the environment within a minute or two.',
    cat: 'Healthy cat rest is layered — most of the day is light, easily interrupted sleep, with several stretches reaching deep rest. Look for easy waking, deep stretching, brief grooming, and re-engagement with the environment.'
  };

  var SIGNS = {
    dog: [
      'A sudden, significant increase in sleep over days or a few weeks',
      'Difficulty settling, pacing, or restlessness at night',
      'Apparent disorientation or distress on waking',
      'Loud snoring, gasping, or sleep that seems labored',
      'Loss of interest in food, walks, or familiar people alongside sleep changes'
    ],
    cat: [
      'A sudden, significant increase in sleep over days or a few weeks',
      'Restlessness, pacing, or vocalizing at night — especially in senior cats',
      'Hiding more than usual or seeking unusual sleep spots',
      'Apparent disorientation or distress on waking',
      'Loss of interest in food, play, or familiar people alongside sleep changes'
    ]
  };

  var ENV = {
    dog: [
      'A consistent, supportive sleep surface — orthopedic for large or senior dogs',
      'A predictable evening rhythm with meals and last walk at similar times',
      'A cool, quiet, low-stimulation rest space',
      'Daily movement that genuinely tires the body and the mind',
      'Calm wind-down before bed — avoid intense play immediately before sleep'
    ],
    cat: [
      'Multiple safe rest spots — elevated, enclosed, or warm — so the cat can choose',
      'A predictable household rhythm with meals and quiet times at similar hours',
      'A warm, draft-free environment, especially for senior cats with stiffer joints',
      'Short daily play sessions that engage hunting drive and tire the mind',
      'Calm wind-down before sleep — avoid intense play immediately before bedtime'
    ]
  };

  function applyAdj(range, adj) {
    if (!adj) return range;
    return [range[0] + adj[0], range[1] + adj[1]];
  }

  function clampRange(r) {
    var low = Math.max(8, Math.min(22, r[0]));
    var high = Math.max(low + 1, Math.min(22, r[1]));
    return [low, high];
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var species = root.getAttribute('data-species') || 'dog';
    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var errorEl    = form.querySelector('[data-error]');
    var resetBtn   = form.querySelector('[data-reset]');
    var resultEl   = root.querySelector('[data-result]');
    var rangeEl    = root.querySelector('[data-result-range]');
    var summaryEl  = root.querySelector('[data-result-summary]');
    var normalEl   = root.querySelector('[data-normal]');
    var ageEl      = root.querySelector('[data-age-change]');
    var healthyEl  = root.querySelector('[data-healthy]');
    var signsEl    = root.querySelector('[data-signs]');
    var envEl      = root.querySelector('[data-env]');

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    function fillList(el, items) {
      el.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        el.appendChild(li);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var age      = (form.querySelector('input[name="age"]:checked') || {}).value || 'adult';
      var activity = (form.querySelector('input[name="activity"]:checked') || {}).value || 'moderate';
      var lifestyle = (form.querySelector('input[name="lifestyle"]:checked') || {}).value || '';
      var advanced  = ((form.querySelector('input[name="advanced"]:checked') || {}).value || 'no') === 'yes';
      var size     = (form.querySelector('input[name="size"]:checked') || {}).value || 'medium';

      var range = (BASE_RANGE[species] && BASE_RANGE[species][age]) || [12, 14];
      range = range.slice();

      if (species === 'dog') {
        range = applyAdj(range, DOG_SIZE_ADJ[size]);
        range = applyAdj(range, DOG_LIFESTYLE_ADJ[lifestyle]);
      } else {
        range = applyAdj(range, CAT_LIFESTYLE_ADJ[lifestyle]);
      }

      range = applyAdj(range, ACTIVITY_ADJ[activity]);
      if (advanced) range = applyAdj(range, ADVANCED_ADJ);

      range = clampRange(range);

      rangeEl.textContent = range[0] + '–' + range[1];
      summaryEl.textContent = INTERP[species][age] || '';
      normalEl.textContent = NORMAL_COPY[species][age] || '';
      ageEl.textContent = AGE_CHANGE_COPY[species];
      healthyEl.textContent = HEALTHY_COPY[species];
      fillList(signsEl, SIGNS[species]);
      fillList(envEl, ENV[species]);

      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function ready() {
    document.querySelectorAll('[data-lpl-sc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-sc]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
